<div>
  <ng-container *ngFor="let breadcrumb of breadcrumbs; last as last; trackBy: trackByUrl">
    <a
      class="breadcrumb-link mat-subtitle-1"
      [routerLink]="[breadcrumb.url]"
      [queryParams]="breadcrumb.urlParams"
      *ngIf="!breadcrumb.isCurrent"
    >
      <ng-container [ngTemplateOutlet]="breadcrumbText" [ngTemplateOutletContext]="{ $implicit: breadcrumb }"></ng-container>
    </a>
    <span class="breadcrumb-current mat-subtitle-1" *ngIf="breadcrumb.isCurrent">
      <ng-container [ngTemplateOutlet]="breadcrumbText" [ngTemplateOutletContext]="{ $implicit: breadcrumb }"></ng-container>
    </span>
    <span class="mat-subtitle-1" *ngIf="!last">&nbsp;/&nbsp;</span>
  </ng-container>

  <ng-template #breadcrumbText let-breadcrumb>
    <span *ngIf="breadcrumb.translatable">{{ breadcrumb.text | translate }}</span>
    <span *ngIf="!breadcrumb.translatable">{{ breadcrumb.text }}</span>
  </ng-template>
</div>
